import React from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import { getSmartDocumentModalTitle } from '../helpers';
import * as selectors from '../selectors';

import SmartDocumentForm from './SmartDocumentForm';

const SmartDocumentModal = ({
    handleClickCloseModal,
    handleClickDocumentItem,
    initTemplate,
    isOpenModal,
    proposalId,
    resetForm,
    resetTemplate,
    smartDocumentFormMode,
}) => {
    return (
        <Dialog
            onClose={handleClickCloseModal}
            onExited={() => resetForm()}
            open={isOpenModal}
            size="md"
            title={getSmartDocumentModalTitle(smartDocumentFormMode)}
        >
            <SmartDocumentForm
                handleClickDocumentItem={handleClickDocumentItem}
                initTemplate={initTemplate}
                proposalId={proposalId}
                resetTemplate={resetTemplate}
                smartDocumentFormMode={smartDocumentFormMode}
            />
        </Dialog>
    );
};

const mapStateToProps = createStructuredSelector({
    isOpenModal: selectors.getIsOpenSmartDocumentModal,
    smartDocumentFormMode: selectors.getSmartDocumentFormMode,
});

const mapDispatchToProps = (dispatch) => ({
    handleClickCloseModal: () => dispatch(actions.openDocumentModal(false)),
    resetForm: () => dispatch(actions.resetDocumentForm()),
});

SmartDocumentModal.propTypes = {
    handleClickCloseModal: PropTypes.func,
    handleClickDocumentItem: PropTypes.func,
    initTemplate: PropTypes.func,
    isOpenModal: PropTypes.bool,
    proposalId: PropTypes.string,
    resetForm: PropTypes.func,
    resetTemplate: PropTypes.func,
    smartDocumentFormMode: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartDocumentModal);
